import { Flex, Table } from '@mantine/core'

import type { TableItemProps } from '@/modules/employerAdvisors/pages/components/TableItem/TableItem.types'

import { Button } from '@/components/Button/Button'
import { Text } from '@/components/Text/Text'

import classes from './TableItem.module.css'

export function TableItem({ empty = false, item }: TableItemProps) {
  if (!item || empty) {
    return (
      <Table.Tr className={classes.emptyTableItem}>
        <Table.Td miw="100%">
          <Text variant="body_2_semibold_black">No users</Text>
        </Table.Td>
      </Table.Tr>
    )
  }

  const handleContactAdvisor = () => {
    window.open(item.calendly, '_blank', 'noreferrer')
  }

  return (
    <Table.Tr className={classes.tableItem}>
      <Table.Td miw={250} w="85%">
        <Text variant="body_2_medium_black">
          {`${item.firstName} ${item.lastName}`}
        </Text>
      </Table.Td>
      <Table.Td miw={160} w="15%">
        <Flex align="center" gap={16}>
          <Button
            h={34}
            miw={0}
            onClick={handleContactAdvisor}
            variant="primary"
          >
            Contact
          </Button>
        </Flex>
      </Table.Td>
    </Table.Tr>
  )
}
